import { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Alert } from "@blueprintjs/core";

import { Code } from "@components";

import { WorkbenchContext } from "@pages/editor/providers";

const ConfirmOverwrite = () => {
  const { workbench } = useContext(WorkbenchContext);

  const overwriteAndClose = () => {
    // Trigger the save method with explicit acknowledgment of overwrite
    workbench.saveBundle(true);
    workbench.ui.closeConfirmOverwriteAlert();
  };

  return (
    <Alert
      isOpen={workbench.ui.isConfirmOverwriteAlertOpen}
      confirmButtonText={"Overwrite"}
      cancelButtonText={"Cancel"}
      onCancel={workbench.ui.closeConfirmOverwriteAlert}
      onConfirm={overwriteAndClose}
      intent="warning"
      icon={"refresh"}
    >
      <p>
        Are you sure you want to overwrite{" "}
        <Code inline light>
          {`${workbench?.org?.name}:${workbench.bundle?.rule?.id}`}
        </Code>{" "}
        with your current rule?
      </p>
      <p>This is a destructive operation and will remove your previous rule.</p>
    </Alert>
  );
};

export const ConfirmOverwriteAlert = observer(ConfirmOverwrite);
